<template>
    <div class="flex flex-col h-screen">
        <Navbar/>
        <div class="container mx-auto px-4 m-8 max-w-screen-full xl:max-w-screen-xl 2xl:max-w-screen-2xl">
            <router-view />
        </div>
        <Footer />
        <Gotop />
    </div>
</template>

<script setup lang="ts">
    import Navbar from "./components/Navbar.vue";
    import Gotop from "./components/Gotop.vue";
    import Footer from "./components/Footer.vue";
</script>
